module.exports = __webpack_public_path__ + "static/media/dadhi.2cf32673.webp";